import React from 'react';

// Dispose the entire form state on close, including files, selections and steps.
// Failed submissions keep the modal open and preserve its current input.
export function freshModal(Form, openProperty = 'isOpen') {
  function FreshModal(props) {
    return props[openProperty] ? <Form {...props} /> : null;
  }
  FreshModal.displayName = `Fresh${Form.displayName || Form.name || 'Modal'}`;
  return FreshModal;
}
